import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Spinner from "../Common/Spinner";
import Dokumenter from "./Dokumenter";
import KlageInfoDetail from "./KlageInfoDetail";

function KlageInfoContainer() {
  const sak = useSelector((state) => state.sak);

  if (isEmpty(sak)) return null;

  return (
    <div className="klageDetailTabs">
      <div className="overskrift">KlageInfo</div>
      <div style={{ marginTop: 20 }}>
        <KlageInfoDetail sak={sak} />
        <Dokumenter sak={sak} />
        <Spinner isLoading={false} />
      </div>
    </div>
  );
}

export default KlageInfoContainer;
